import { Typography } from '@mui/material';
import type { FileSearchRecord } from '@repo/api-gw-sdk';

import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';
import { base64UrlEncode } from '@/utils/string';

export const PathCell = ({ entity }: { entity: FileSearchRecord }) => {
  const { isAuthorized } = useRoles();
  return (
    entity.path && (
      <TextLink
        disabled={!isAuthorized('read:files')}
        href={`/explorer/${entity.resourceId}?file=${base64UrlEncode(entity.path)}`}
      >
        <Typography className='hover:text-[var(--mui-palette-text-gray1)]'>
          {entity.path}
        </Typography>
      </TextLink>
    )
  );
};
